import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';

const UpdateSuccessDialog = ({
  open,
  setOpen,
  totalProducts,
  currentIndex,
}) => {
  const handleClose = () => setOpen(false);
  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogContent>
        <DialogContentText>
          Fulfillment times updated successfully !
        </DialogContentText>
        {currentIndex > 0 && (
          <DialogContentText>
            {currentIndex} / {totalProducts}
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color='primary'>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UpdateSuccessDialog;
